import React from 'react'

const TopBar = () => {
  return (
    <div id="top-bar" style={{backgroundColor: 'rgb(48, 48, 222)',paddingBlock:'10px', color:'aliceblue', zIndex: '100'}}>
    <div  className="row d-flex justify-content-center mx-3">
        <div className="col-12"><i className="fa-solid fa-location-crosshairs"></i> Top High, Kumasi, AK-250-6656</div>      
    </div>
    <div className="row mx-3">
        <div style={{padding: 0, margin: 0}} className="col-7"><i className="fa-regular fa-envelope"></i> info@phgafrica.org</div>
        <div style={{padding: 0, margin: 0}} className="col-5"><i className="fa-solid fa-phone"></i>+233242029161</div>
    </div>
 </div>


  )
}

export default TopBar